import { put, takeLatest } from 'redux-saga/effects';
import SagasHelper from "../../helpers/Redux/SagasHelper";
import { PaymentActions } from "./actionCreators";
import { PAYMENT_ACTION } from "./actionTypes";
import { PaymentApi } from "./api";

function* responseHandler(response) {
  yield put(PaymentActions.setList(Object.values(response.result)));
}
/**
 * List payment cards
 *
 * @param {object} action
 *
 * @return {IterableIterator<PutEffect<{type, message}>|PutEffect<{cities, type}>|CallEffect|PutEffect<{type}>>}
 */


function* list(action) {
  yield SagasHelper.action(action, PaymentApi.list, null, null, responseHandler);
}
/**
 * Create payment card
 *
 * @param {object} action
 *
 * @return {IterableIterator<PutEffect<{type, message}>|PutEffect<{cities, type}>|CallEffect|PutEffect<{type}>>}
 */


function* create(action) {
  yield SagasHelper.action(action, PaymentApi.create);
}
/**
 * Send post data after 3D secure done
 *
 * @param {object} action
 *
 * @return {IterableIterator<PutEffect<{type, message}>|PutEffect<{cities, type}>|CallEffect|PutEffect<{type}>>}
 */


function* postSecure(action) {
  yield SagasHelper.action(action, PaymentApi.postSecure);
}
/**
 * Delete payment card
 *
 * @param {object} action
 *
 * @return {IterableIterator<PutEffect<{type, message}>|PutEffect<{cities, type}>|CallEffect|PutEffect<{type}>>}
 */


function* deleteCard(action) {
  yield SagasHelper.defaultAction(action, PaymentApi.delete, null, null, responseHandler);
}
/**
 * Set primary payment card
 *
 * @param {object} action
 *
 * @return {IterableIterator<PutEffect<{type, message}>|PutEffect<{cities, type}>|CallEffect|PutEffect<{type}>>}
 */


function* setMain(action) {
  yield SagasHelper.defaultAction(action, PaymentApi.setMain, null, null, responseHandler);
}
/**
 * Add new card with redirect.
 *
 * @param {Object} action
 *
 * @return {IterableIterator<PutEffect<{type, message}>|PutEffect<{cities, type}>|CallEffect|PutEffect<{type}>>}
 */


function* createWithRedirect(action) {
  yield SagasHelper.action(action, PaymentApi.createWithRedirect, null, null, function* (response) {
    yield put(PaymentActions.setCreateWithRedirect(response.result));
  });
}

export default [takeLatest(PAYMENT_ACTION.LIST, list), takeLatest(PAYMENT_ACTION.CREATE, create), takeLatest(PAYMENT_ACTION.POST_SECURE, postSecure), takeLatest(PAYMENT_ACTION.DELETE, deleteCard), takeLatest(PAYMENT_ACTION.SET_MAIN, setMain), takeLatest(PAYMENT_ACTION.CREATE_WITH_REDIRECT, createWithRedirect)];